<template>
    <li v-hover-classes="['bg-white-darker-2']" class="story padding-left-big padding-right-big border-top border-ink-lighter-3 padding-vertical-normal">
        <div class="story-name margin-right-normal">
            <input @input="editStoryName($event.target.value)" @keydown.enter="$emit('addstory');" ref="storyName" type="text" class="regular small margin-vertical-0 padding-vertical-xtiny padding-horizontal-tiny negative-margin-left-tiny" :value="story.name" placeholder="Nome da Story..."/>
        </div>
        <div class="margin-left-auto story-tags">
            <bbox-tag style="cursor: pointer" tabindex="0" @click.native="toggleTagInStory('Front-end');" @keyup.native.enter="toggleTagInStory('Front-end');" class="margin-horizontal-xtiny" :neutral="!!tagsProps['Front-end'] && !!tagsProps['Front-end'].neutral" :success="!!tagsProps['Front-end'] && !!tagsProps['Front-end'].success">Front-end</bbox-tag>
            <bbox-tag style="cursor: pointer" tabindex="0" @click.native="toggleTagInStory('Back-end');" @keyup.native.enter="toggleTagInStory('Back-end');" class="margin-horizontal-xtiny" :neutral="!!tagsProps['Back-end'] && !!tagsProps['Back-end'].neutral" :success="!!tagsProps['Back-end'] && !!tagsProps['Back-end'].success">Back-end</bbox-tag>
        </div>
        <div class="story-points margin-left-normal">
            <bbox-select 
                :options="[1,3,5,8,13,21]" 
                name="storyPoints" 
                :value="story.points"
                
                @change="editStoryPoints($event)"
                inputClasses="padding-horizontal-normal padding-vertical-tiny bg-transparent border border-transparent border-focus-blue-lighter-2 font-size-big"
                optionClasses="border-top border-bottom border-white-darker-3 padding-horizontal-normal padding-vertical-tiny font-size-big bg-white-base bg-hover-blue-lighter-4"
                optionHoverClasses="border-top border-bottom border-white-darker-3 padding-horizontal-normal padding-vertical-tiny font-size-big bg-blue-lighter-4" />
            <!-- <input @keyup.enter="$emit('addstory');" ref="storyPoints" type="number" :value="story.points" class="regular small margin-vertical-xxtiny" placeholder="Story Points" /> -->
        </div>
        <div tabindex="0" @keydown.enter="$store.dispatch('removeStoryByIdFromRelease', {releaseId, storyId: story.id})" @click="$store.dispatch('removeStoryByIdFromRelease', {releaseId, storyId: story.id})" class="remove-story font-size-big margin-left-normal">
            <b-icon><icon-delete></icon-delete></b-icon>
        </div>
    </li>
</template>

<script>
import BboxTag from '@/dls/components/Tag.vue';
import BboxSelect from '@/dls/components/Select.vue';
import BIcon from '@/dls/components/Icon.vue'
import IconDelete from '@/dls/icons/icon-delete.svg'
import BboxHoverClassDirective from '@/dls/directives/BboxHoverClass.js';
import debounce from 'lodash.debounce';

export default {
    name: 'bbox-story',
    directives: {'hover-classes': BboxHoverClassDirective},
    components: {
        BboxTag,
        BboxSelect,
        BIcon,
        IconDelete
        },
    props: {
        story: Object,
        releaseId: Number
    },
    methods: {
        toggleTagInStory(tag) {
            if(this.story.tags.includes(tag)) {
                var index = this.story.tags.indexOf(tag);
                this.story.tags.splice(index,1);
            } else {
                this.story.tags.push(tag);
            }
            this.$store.dispatch('replaceStoryFromRelease', {releaseId: this.releaseId, story: this.story});
        },
        editStoryName: debounce(function(name) {
                            this.story.name = name;
                            this.$store.dispatch('replaceStoryFromRelease', {releaseId: this.releaseId, story: this.story});
                        }, 350),
        editStoryPoints(points) {
            this.story.points = points;
            this.$store.dispatch('replaceStoryFromRelease', {releaseId: this.releaseId, story: this.story});
        }
    },
    computed: {
        tagsProps() {
            var tags = {
                'Front-end': {neutral: true, success: false},
                'Back-end': {neutral: true, success: false}
            };
            for(var i in this.story.tags) {
                if(tags[this.story.tags[i]]) {
                    tags[this.story.tags[i]] = {neutral: false, success: true}
                }
            }
            return tags;
        }
    },
    mounted() {
        this.$refs.storyName.focus();
    }
}
</script>

<style lang="scss" scoped>
    .story {
        display: flex;
        align-content: center;
        align-items: center;
        .remove-story {
            opacity: 0;
            cursor: pointer;
            &:focus {
                opacity: 1;
            }
        }
        &:hover .remove-story {
            opacity: 1;
        }
    }
    .story-name {
        flex-grow: 100;
        input {
            width: 100%;
        }
    }
    input {
        border: none;
        outline: none;
        background: transparent;
        &[type=number] {
            width: 96px;
            -webkit-appearance: none;
            -moz-appearance: textfield;
            &::-webkit-outer-spin-button, &::-webkit-inner-spin-button {
                -webkit-appearance: none;
                margin: 0;
            }
        }
    }
</style>